import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function DataMaintenance() {
    return (
        <main className="relative overflow-hidden bg-gradient-to-b from-slate-900 to-black text-gray-100 py-16">
            <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-12">

                {/* Text Section */}
                <div className="flex-1 z-10">
                    <h1 className="text-4xl font-bold text-white">
                        Data Maintenance & Optimization
                    </h1>
                    <p className="mt-4 text-lg text-gray-300 leading-relaxed">
                        Our Data Maintenance services help organizations manage, cleanse,
                        and optimize their critical identity and HR data. We ensure accuracy,
                        compliance, and reliability across all integrated systems.
                    </p>

                    <h2 className="mt-8 text-2xl font-semibold text-white">Key Services</h2>
                    <ul className="mt-3 list-disc pl-6 text-gray-300 space-y-2">
                        <li>Secure record cleanup and deduplication</li>
                        <li>Data synchronization between systems</li>
                        <li>Audit-ready compliance reports</li>
                        <li>Ongoing data lifecycle management</li>
                    </ul>

                    <p className="mt-8 text-gray-300">
                        SecureID Technologies applies strict access controls, encryption, and
                        data retention policies that meet government and enterprise standards.
                        Your data remains accurate, accessible, and audit-ready.
                    </p>

                    <p className="mt-10 text-center lg:text-left text-sm text-gray-400">
                        <Link to="/" className="text-indigo-400 hover:underline">
                            ← Back to Home
                        </Link>
                    </p>
                </div>

                {/* Animated Image (Moved After Text) */}
                <motion.div
                    className="flex-1 flex justify-center"
                    initial={{ opacity: 0, y: 100 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1.2, ease: "easeOut" }}
                >
                    <img
                        src="/Images/data-maintenance.jpg"
                        alt="Data Maintenance illustration"
                        className="w-[90%] max-w-md rounded-2xl shadow-2xl"
                    />
                </motion.div>
            </section>
        </main>
    );
}
